import { useRouter } from 'next/router';
import { Fragment, useState, useRef, useContext, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Image from "next/image";
import style from "./modal_error.module.css";
import Button from "@/components/UI/button/button";
import { AlertContext } from '@/stores/alert-context'

export default function ModalError() {
  const router = useRouter()
  const [state, dispatch] = useContext(AlertContext)
  const [isOpen, setIsOpen] = useState(false)
  const modalRef = useRef(null);
  const [heading, setHeading] = useState('ขออภัย! เกิดข้อผิดพลาดขึ้น')
  const [htmlMessage, setHtmlMessage] = useState('<p>ขณะนี้ระบบกำลังขัดข้อง <br/> กรุณากด <b>ลองใหม่อีกครั้ง</b> <br/>หรือ ติดต่อเจ้าหน้าที่ โทร. 1737 </p>')

  useEffect(() => {
    const { heading, message, action } = state.modalShower

    if (heading) setHeading(heading)
    if (message) setHtmlMessage(message)
    setIsOpen(true)
  }, [state.modalShower])

  useEffect(() => {
    setIsOpen(false)
  }, [router])

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <Fragment>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          initialFocus={modalRef}
          className={style.modal}
          onClose={closeModal}
        >
          <div>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className={style.overlay} />
            </Transition.Child>
            <span
              className="inline-block h-screen align-top"
              aria-hidden="true"
            ></span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className={style.modal_container}>
                <div className={style.modal_body}>
                  <Image
                    alt="error-modal-icon"
                    src="/assets/icon-svg/warning.svg"
                    width={40}
                    height={40}
                    priority={true}
                  />
                  <h4>
                    {heading}
                  </h4>
                  <p dangerouslySetInnerHTML={{ __html: htmlMessage }}/>
                  <Button color="blue" text="ตกลง" onClick={closeModal} />
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </Fragment>
  );
}
